"use client";

import React from "react";

import CoverForFormSection from "@/app/components/cover-for/components/form-section";
import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import CoverForDescriptionSection from "./components/description-section";
import FamilyModal from "./components/form-section/family-modal/family-modal";
import useCoverForHook from "./hook/cover-for.hook";
import { useCoverForContext } from "./provider/cover-for.provider";

function CoverFor() {
  const {
    selectedAnswer,
    isOpenUnsavedChangesModal,
    cmsData,
    setIsOpenUnsavedChangesModal,
    handleUnSavedWarningMessageContinueBtn,
    scrollRefArray,
    isFamilyModalOpen,
  } = useCoverForContext();
  const {
    isHideFooterBack,
    isFooterLoading,
    loading,
    handleSubmitButton,
    handleBackButton,
  } = useCoverForHook();
  const { backToRenewalsText, ctaButtonText } = cmsData.overlayArea[0];
  const { current } = useWizard();

  return (
    <>
      <FamilyModal />
      <QuestionLayout
        footer={{
          isHideFooterBack,
          isLoading: loading || isFooterLoading,
          isDisabledBack: false,
          isDisabledContinue: selectedAnswer === "DEFAULT" || isFamilyModalOpen,
          footerActionBack: () => {
            handleBackButton();
          },
          footerActionContinue: () => {
            handleSubmitButton();
          },
          id: "cover-for-footer",
          ctaButtonText: ctaButtonText ?? "Continue",
        }}
        formSection={<CoverForFormSection />}
        descriptionContent={<CoverForDescriptionSection />}
        progressBarPercent={current.progressBarPercentage ?? 37.5}
        backToRenewalSection={{
          isOpenUnsavedChangesModal,
          backToRenewalText: backToRenewalsText ?? "Back to Renewal",
          onContinueClick: handleUnSavedWarningMessageContinueBtn,
          setIsOpenUnsavedChangesModal,
        }}
        scrollRefs={scrollRefArray}
      />
    </>
  );
}

export default CoverFor;
